<template>
    <div class="hamburger-container" @click="toggleClick">
        <el-icon v-if="$store.getters.sidebarOpened"><Fold /></el-icon>
        <el-icon v-else><Expand /></el-icon>
        <!-- <el-button :icon="$store.getters.sidebarOpened ? Fold : Expand" /> -->
        <!-- <svg-icon id="guide-hamburger" className="hamburger" :icon="icon"></svg-icon> -->
    </div>
</template>
<script setup>
// import { computed } from 'vue'
import { useStore } from 'vuex'
import { Expand, Fold } from '@element-plus/icons'
const store = useStore()
const toggleClick = () => {
    store.commit('app/triggerSidebarOpened')
}

// const icon = computed(() => (store.getters.sidebarOpened ? 'hamburger-opened' : 'hamburger-closed'))
</script>

<style lang="scss" scoped>
.hamburger-container {
    // padding: 0 16px;
    background-color: #FFFFFF;
    padding: 0px 5px;
    border-radius: 5px;
    padding-top: 5px;
    box-shadow: var(--el-box-shadow-light);
    .el-icon{
        color: #8d8888;
        font-size: 20px;
    }

    :deep(.hamburger) {
        display: inline-block;
        vertical-align: middle;
        width: 20px;
        height: 20px;
    }
}
</style>
